import { createEntityAdapter } from '@reduxjs/toolkit';

import type { Student } from '../../types/student';

export const adapter = createEntityAdapter<Student>({
  selectId: (student) => student.name
});
export const selector = adapter.getSelectors();
